import Dexie from 'dexie';

const DATABASE_VERSION = 12;
export const db = new Dexie('backoffice');
db.version(DATABASE_VERSION).stores({
	// Primary key and indexed props
	genericTable: '[table+field], value, date',
	products: 'id, nome, descrizione_breve, prezzo, imageUrl, sku, slug',
	productAttributes: '++id, prodotto_id, name, value',
	attributi: 'id, nome',
	attributiValori: 'id, attributo_id, valore',
	logs: '++id, timestamp, type, message, details',
	users: '++id, user, username, first_name, last_name, is_bot, language_code, date, last_update, next_update, auth',
	strings: '[string+language], description, date, user, bot',
	categories: 'id, nome, parent_id, slug',
	techyshop_prodotto_categoria: '[prodotto_id+categoria_id], prodotto_id, categoria_id',
	techyshop_utenti: 'id, email, nome, cognome, attivo',
	telegramMessages: 'message, telegram_message_id, user, chat, bot, date'
});
